import { useTranslation } from 'react-i18next';
import { OutputContainer } from '../../../style';
import { useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';
export const TemplateOutputView = () => {
  const { t } = useTranslation('designs');
  const { compiledTemplate } = useTemplateEditorState();

  return (
    <OutputContainer data-testid="OutputView">
      <textarea
        title={t('designGallery.templateEditor.templateOutputView.textareaTitle')}
        value={compiledTemplate}
        readOnly
      />
    </OutputContainer>
  );
};
